import { Input, Space, Form, Switch, Button } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'
import { NewAdministratorFormProps } from './types'

function NewSystemAdministratorForm({ onFinish, loading }: NewAdministratorFormProps): JSX.Element {
  return (
    <Form
      name="newservice"
      onFinish={onFinish}
      labelAlign="left"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 12 }}
      className="new-service-form"
    >
      <Space direction="vertical" size={16}>
        <Form.Item label="Full Name" style={{ overflow: 'auto' }} name="Full name">
          <Input />
        </Form.Item>

        <Form.Item label="Email Address" style={{ overflow: 'auto' }} name="Email">
          <Input />
        </Form.Item>
        <Form.Item label="Phone Number" style={{ overflow: 'auto' }} name="Phone Number">
          <Input />
        </Form.Item>

        <Form.Item label="Status" help="Active or Disabled" style={{ overflow: 'auto' }} name="switch">
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
          <Button type="primary" htmlType="submit" loading={loading} icon={<PlusCircleOutlined />}>
            Add Administrator
          </Button>
        </Form.Item>
      </Space>
    </Form>
  )
}

export default NewSystemAdministratorForm
